@use "../../styles/variables" as vars;

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  @include vars.flex-center;
  z-index: 1000;
  padding: 1rem;
  box-sizing: border-box;

  &--white {
    background-color: rgba(245, 245, 245, 0.9);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
  }
}

.modal-container {
  background-color: vars.$background-card;
  border-radius: 16px;
  width: 100%;
  max-width: 500px;
  max-height: 85vh;
  max-height: 85dvh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 16px 50px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  position: relative;

  &--close-only {
    justify-content: flex-end;
    padding: 12px 12px 4px 12px;
  }

  @media (min-width: 1024px) {
    padding: 24px;
  }
}

.modal-title {
  margin: 0;
  font-family: vars.$font-family-base;
  font-size: 14px;
  font-weight: 600;
  color: vars.$text-black;
  letter-spacing: -0.5px;
}

.modal-close-btn {
  position: absolute;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 20px;
  height: 20px;
  @include vars.flex-center;
  color: vars.$text-black;
  font-size: 20px;
  transition: color 0.2s ease;

  &:hover {
    color: vars.$text-grey-medium;
  }

  &:focus {
    outline: none;
  }
}

.modal-body {
  padding: 0 20px 20px;
  overflow-y: auto;
  flex: 1;
}

.modal-overlay--bottom-sheet {
  align-items: flex-end;
  padding: 0;
}

.bottom-sheet-modal {
  position: absolute;
  bottom: 0;
  border-radius: 20px 20px 0 0;
  max-width: 100%;
  animation: slideUp 0.3s ease-out;
  touch-action: pan-y;
  will-change: transform;

  .modal-body {
    padding: 1rem;
    overscroll-behavior-y: contain;
  }
}

.bottom-sheet-header {
  padding: 0 0 0.5rem 0;
  text-align: left;
  border-bottom: 1px solid vars.$border-grey-light;
  touch-action: none;

  .drag-handle {
    width: 40px;
    height: 4px;
    background-color: #cbd5e0;
    border-radius: 2px;
    margin: -0.5rem auto 1rem;
    cursor: grab;
    touch-action: none;

    &:active {
      cursor: grabbing;
    }
  }

  .modal-title {
    font-size: vars.$font-size-20;
    font-weight: vars.$font-weight-extra-bold;
    margin-bottom: 0.25rem;
  }

  .modal-subtitle {
    font-size: vars.$font-size-md;
    color: vars.$text-grey-medium;
    margin: 0;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
